export default __webpack_public_path__ + "static/media/profile-default.9693afa3.png";